import {
  Avatar,
  Modal,
  message
} from "antd";

import {
  AppstoreOutlined,
  BellOutlined,
  BookOutlined,
  CustomerServiceOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
  GiftOutlined,
  GlobalOutlined,
  IdcardOutlined,
  LockOutlined,
  LogoutOutlined,
  MobileOutlined,
  RightOutlined,
  SafetyCertificateOutlined,
  ShoppingCartOutlined,
  UserOutlined
} from "@ant-design/icons";

import {
  useEffect,
  useMemo
} from "react";

import {
  useNavigate
} from "react-router-dom";

import {
  useDevice
} from "../../hooks";

import {
  accountSections
} from "./accountConfig";

const { confirm } = Modal;

const icons = {
  profile: <UserOutlined />,
  orders: <ShoppingCartOutlined />,
  books: <BookOutlined />,
  addresses: <EnvironmentOutlined />,
  vouchers: <GiftOutlined />,
  notifications: <BellOutlined />,
  blog: <GlobalOutlined />,
  utilities: <AppstoreOutlined />,
  password: <LockOutlined />,
  devices: <MobileOutlined />,
  privacy: <SafetyCertificateOutlined />,
  copyright: <IdcardOutlined />,
  support: <CustomerServiceOutlined />,
  logout: <LogoutOutlined />
};

const readUser = () => {
  try {
    return JSON.parse(
      localStorage.getItem("user")
    );
  } catch (e) {
    return null;
  }
};

export default function Profile() {
  const navigate = useNavigate();
  const { isMobile } = useDevice();

  const user = useMemo(
    () => readUser(),
    []
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }, []);

  if (!user) {
    navigate(
      "/dang-nhap",
      { replace: true }
    );

    return null;
  }

  const name =
    user?.fullname ||
    user?.displayName ||
    user?.email ||
    "Khách hàng";

  const initial =
    String(name)
      .trim()
      .charAt(0)
      .toUpperCase();

  const handleLogout = () => {
    confirm({
      title: "Bạn có chắc chắn muốn đăng xuất?",
      icon: <ExclamationCircleOutlined />,
      okText: "Đăng xuất",
      okType: "danger",
      cancelText: "Hủy",

      onOk() {
        localStorage.removeItem("user");
        localStorage.removeItem("user_token");
        localStorage.removeItem("token");

        document.cookie =
          "user=; Max-Age=0; path=/";

        message.success(
          "Đăng xuất thành công!"
        );

        navigate("/dang-nhap");
      }
    });
  };

  const openItem = item => {
    if (item.action === "logout") {
      handleLogout();
      return;
    }

    if (item.url) {
      if (
        String(item.url).startsWith("/")
      ) {
        window.location.href = item.url;
      } else {
        window.open(
          item.url,
          "_blank",
          "noopener,noreferrer"
        );
      }

      return;
    }

    if (item.path) {
      navigate(item.path);
    }
  };

  const groups = [
    ["account", "Tài khoản"],
    ["discover", "Khám phá"],
    ["security", "Bảo mật"],
    ["legal", "Pháp lý"],
    ["support", "Hỗ trợ"]
  ];

  return (
    <div
      className={`
        min-h-screen
        bg-[#f5f7fb]
        ${isMobile ? "pb-28" : "py-7"}
      `}
    >
      <div
        className="
          max-w-4xl
          mx-auto
          px-3
          md:px-6
        "
      >
        <div
          className="
            bg-gradient-to-br
            from-blue-600
            to-blue-800
            rounded-[24px]
            p-5
            md:p-6
            text-white
            shadow-[0_12px_38px_rgba(37,99,235,0.18)]
            mb-4
          "
        >
          <div
            className="
              flex
              items-center
              gap-4
            "
          >
            <Avatar
              size={70}
              src={user?.photos || undefined}
              className="
                !bg-white
                !text-blue-600
                border-[3px]
                border-white/60
                font-bold
                text-xl
              "
            >
              {!user?.photos && initial}
            </Avatar>

            <div className="min-w-0">
              <p
                className="
                  text-[12px]
                  text-blue-100
                  m-0
                "
              >
                Xin chào,
              </p>

              <h1
                className="
                  text-[21px]
                  font-bold
                  text-white
                  truncate
                  mt-1
                  mb-0
                "
              >
                {name}
              </h1>

              <p
                className="
                  text-[12px]
                  text-blue-100
                  truncate
                  mt-1
                  mb-0
                "
              >
                {user?.email}
              </p>
            </div>
          </div>
        </div>


        {groups.map(([group, title]) => {
          const items =
            accountSections.filter(
              item => item.group === group
            );

          if (!items.length) {
            return null;
          }

          return (
            <div
              key={group}
              className="mb-4"
            >
              <h2
                className="
                  text-[12px]
                  uppercase
                  tracking-[0.11em]
                  font-bold
                  text-slate-400
                  px-2
                  mb-2
                "
              >
                {title}
              </h2>

              <div
                className="
                  bg-white
                  rounded-[20px]
                  border
                  border-slate-100
                  overflow-hidden
                  shadow-[0_5px_20px_rgba(15,23,42,0.035)]
                "
              >
                {items.map((item, index) => (
                  <button
                    key={item.key}
                    type="button"
                    onClick={() =>
                      openItem(item)
                    }
                    className={`
                      w-full
                      border-0
                      bg-white
                      px-4
                      py-4
                      flex
                      items-center
                      gap-3
                      text-left
                      hover:bg-slate-50
                      transition
                      ${
                        index !== items.length - 1
                          ? "border-b border-slate-100"
                          : ""
                      }
                    `}
                  >
                    <span
                      className="
                        w-11 h-11
                        rounded-xl
                        bg-blue-50
                        text-blue-600
                        flex
                        items-center
                        justify-center
                        text-[19px]
                        shrink-0
                      "
                    >
                      {icons[item.key]}
                    </span>

                    <span
                      className="
                        flex-1
                        min-w-0
                      "
                    >
                      <span
                        className="
                          block
                          text-[14px]
                          font-bold
                          text-slate-800
                        "
                      >
                        {item.title}
                      </span>

                      <span
                        className="
                          block
                          text-[11px]
                          md:text-[12px]
                          text-slate-400
                          mt-0.5
                        "
                      >
                        {item.description}
                      </span>
                    </span>

                    <RightOutlined
                      className="
                        text-[11px]
                        text-slate-300
                      "
                    />
                  </button>
                ))}
              </div>
            </div>
          );
        })}


        <button
          type="button"
          onClick={handleLogout}
          className="
            w-full
            border
            border-red-100
            bg-white
            rounded-[20px]
            px-4
            py-4
            flex
            items-center
            gap-3
            text-left
            shadow-[0_5px_20px_rgba(15,23,42,0.035)]
            mb-4
          "
        >
          <span
            className="
              w-11 h-11
              rounded-xl
              bg-red-50
              text-red-600
              flex
              items-center
              justify-center
              text-[19px]
            "
          >
            <LogoutOutlined />
          </span>

          <span className="flex-1">
            <span
              className="
                block
                text-[14px]
                font-bold
                text-red-600
              "
            >
              Đăng xuất
            </span>

            <span
              className="
                block
                text-[11px]
                text-red-400
                mt-0.5
              "
            >
              Thoát khỏi tài khoản
            </span>
          </span>
        </button>
      </div>
    </div>
  );
}
